import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import {
  locationEndofdaySettingsGetEmployeeReportSettings,
  locationsGetById,
} from "~/api-refs";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

import { EndOfDayEmployeeSettingsForm } from "../../../../../components/end-of-day/employee-report-form";
import { isEmployeeReportSettings } from "../../../../../components/end-of-day/employee-report-types";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/end-of-day/employee-report"
)({
  component: EndOfDayEmployeeSettingsPage,
});

function EndOfDayEmployeeSettingsPage() {
  const { id } = Route.useParams();

  const { data: settings, isPending: settingsLoading } = useQuery(
    convexQuery(locationEndofdaySettingsGetEmployeeReportSettings, {
      locationId: toConvexTableId("locations", id),
    })
  );
  const { data: location, isPending: locationLoading } = useQuery(
    convexQuery(locationsGetById, {
      id: toConvexTableId("locations", id),
    })
  );

  if (settingsLoading || locationLoading) {
    return <LoadingPanel message="Loading settings..." />;
  }

  if (!location) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="body text-foreground text-weight-medium text-balance">
          Employee Report Settings
        </h2>
        <p className="body-sm text-muted-foreground">
          Configure how employee reports should be displayed and printed.
        </p>
      </div>
      <EndOfDayEmployeeSettingsForm
        employee={null}
        employeeId={null}
        location={{
          id: location._id,
          name: location.name,
          address: location.address
            ? {
                id: location.address._id,
                addressLine1: location.address.addressLine1,
                addressLine2: location.address.addressLine2,
                city: location.address.city,
                zipCode: Number.parseInt(location.address.zipCode, 10),
                state: location.address.state,
              }
            : null,
        }}
        locationId={id}
        settings={isEmployeeReportSettings(settings) ? settings : null}
      />
    </div>
  );
}
